// extracted by mini-css-extract-plugin
module.exports = {"people-container":"people_people-container__2CPuG","header":"people_header__3bb8O"};